/**
 * SubscribeForm component.
 * @author We Are Duo
 */
export default class SubscribeForm {
  /**
   * Constructs a new SubscribeForm component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor(options) {
		this.element = options.element
		
		window.addEventListener('load', (event) => {
			this.emailField = this.element.querySelector('.email-holder input')
			this.emailField.placeholder = "Enter email address"
		})

  }
}



// WEBPACK FOOTER //
// ./components/vouchers-subscribe/index.js